import React from "react";
import { connect } from "react-redux";
import "./styles.css";
import lastMinute from "../images/lastMinute.svg";
import earlyBird from "../images/earlyBird.svg";
import custom from "../images/custom.svg";
import newUser from "../images/newUser.svg";
import seatLevel from "../images/seatLevel.svg";
import femaleIcon from "../images/femaleDeal.svg";
import newBadge from "../images/newBadge.svg";

const Card = (props) => {
  const cardImage = [lastMinute, earlyBird, seatLevel, newUser, custom, custom, femaleIcon];
  const { getDealData = {} } = props;
  return (
    <>
    {!props.isEditCase && <p className="selectDealText">Select deal type</p>}
    <div className="row">
      <div className="col-xs-12">
        <div className="row">
        {getDealData && getDealData.dealTypes && getDealData.dealTypes.length > 0 && getDealData.dealTypes.map((element, index) => {
        return (
          <div className="col-xs-3" key={index}>
            <div className="cardBlock" onClick={() => {
                 props.setDealSelected(index, element.label, element.type);
                 props.setDealType(element);
                 localStorage.setItem('service_List', []);
              }}>
              {element.type === "FEMALE_DEAL" && <img className="cardNew" src={newBadge} alt={element.type} />}
              <div className="cardImgMdl">
              <img className="cardImg" src={cardImage[index]} alt={element.type} />
              </div>
              <div className="textHeader">{element.label}</div>
              <div className="textSubHeader">{element.description}</div>
              <div className="btnContainer" onClick={() => {
                props.setDealSelected(index, element.label, element.type);
                 props.setDealType(element);
                 localStorage.setItem('service_List', []);
                 localStorage.setItem('source', '');
                 localStorage.setItem('destination', '');
                //  localStorage.setItem('seatCliked', false);
              }}>
                <div className="btn">Create Deal</div>
              </div>
            </div>
          </div>
        );
      })}
        </div>
      </div>
      {/* <div className="col-xs-3 tipsData">
        <div className="tipsDataHeader">
          <div className="tipsDataText">Tips to create a better deal</div>
          <ul>
            <li>Over 150 operators have already generated attractive deals, resulting in weekly earnings of ₹15,000.</li>
            <li>50 operators are currently offering last-minute deals on their respective routes.</li>
             <li>There is a 10% discount running on most operator buses on the Delhi to Manali route.</li>
             <li>50 operators are currently offering last-minute deals on their respective routes.</li>
             <li>There is a 10% discount running on most operator buses on the Delhi to Manali route.</li>
          </ul>
        </div>
      </div> */}
    </div>
    </>
  );
};

const mapStateToProps = store => ({
  getDealData: store.dealsReducer.getDealData,
})

const mapDispatchToProps = () => ({
})

Card.propTypes = {}

export default connect(mapStateToProps, mapDispatchToProps)(Card)
